import { render, staticRenderFns } from "./ServicesService.vue?vue&type=template&id=21e77726&scoped=true&"
import script from "./ServicesService.vue?vue&type=script&lang=js&"
export * from "./ServicesService.vue?vue&type=script&lang=js&"
import style0 from "./ServicesService.vue?vue&type=style&index=0&id=21e77726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e77726",
  null
  
)

export default component.exports